import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { HttpHeaders } from '@angular/common/http';
import { Prestation } from 'src/app/shared/models/prestation';

@Injectable({
	providedIn: 'root'
})
export class SuiviPrecoService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllSuiviPreco(): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.suiviPrecoUrl}/all`,
			'getAllSuiviPreco'
		);
	}


	getSuiviPrecoById(id: number): Observable<Prestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.suiviPrecoUrl}/get/${id}`,
			'getSuiviPrecoById'
		);
	}

	updateSuiviPreco(suiviPreco: Prestation): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.suiviPrecoUrl}/update/${suiviPreco.id}`,
			'updateSuiviPreco',
			suiviPreco
		);
	}

	addSuiviPreco(suiviPreco: Prestation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.suiviPrecoUrl}/add`,
			'addSuiviPreco',
			suiviPreco
		);
	}

	deleteSuiviPreco(suiviPrecoId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.suiviPrecoUrl}/delete/${suiviPrecoId}`,
			`deleteSuiviPreco`
		);
	}

}
